import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { max as d3max, min as d3min } from 'd3-array';
import { applyStyle } from '../utils';
import { select } from '../../utils/selection';
import { HeatmapRenderer } from './renderer';
function deleteKey(obj, fn) {
  return Object.keys(obj).reduce(function (r, k) {
    var v = obj[k];
    if (!fn(v, k)) r[k] = v;
    return r;
  }, {});
}
export var Heatmap = function Heatmap(options, context) {
  var gradient = options.gradient,
    opacity = options.opacity,
    maxOpacity = options.maxOpacity,
    minOpacity = options.minOpacity,
    blur = options.blur,
    useGradientOpacity = options.useGradientOpacity,
    style = __rest(options, ["gradient", "opacity", "maxOpacity", "minOpacity", "blur", "useGradientOpacity"]);
  var coordinate = context.coordinate,
    createCanvas = context.createCanvas,
    document = context.document;
  return function (points, value, defaults) {
    var transform = value.transform;
    var _coordinate$getSize = coordinate.getSize(),
      _coordinate$getSize2 = _slicedToArray(_coordinate$getSize, 2),
      width = _coordinate$getSize2[0],
      height = _coordinate$getSize2[1];
    var data = points.map(function (p) {
      return {
        x: p[0],
        y: p[1],
        value: p[2],
        radius: p[3]
      };
    });
    var min = d3min(points, function (p) {
      return p[2];
    });
    var max = d3max(points, function (p) {
      return p[2];
    });
    var options = {
      gradient: gradient,
      opacity: opacity,
      minOpacity: minOpacity,
      maxOpacity: maxOpacity,
      blur: blur,
      useGradientOpacity: useGradientOpacity
    };
    var ctx = width && height ? HeatmapRenderer(width, height, min, max, data, deleteKey(options, function (v) {
      return v === undefined;
    }), createCanvas) : {
      canvas: null
    };
    return select(document.createElement('image', {})).call(applyStyle, defaults).style('x', 0).style('y', 0).style('width', width).style('height', height).style('src', ctx.canvas).style('transform', transform).call(applyStyle, style).node();
  };
};
Heatmap.props = {
  defaultMarker: 'point',
  defaultEnterAnimation: 'fadeIn',
  defaultUpdateAnimation: 'morphing',
  defaultExitAnimation: 'fadeOut'
};